import styled from 'styled-components';

const Header = styled.h1`
  margin: 1em 0 0.7em 0;
  width: 100%;
`;

export default Header;
